var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('va-action-button',{attrs:{"label":"Export","icon":"mdi-download","text":"","loading":_setup.loading,"color":"green"},on:{"click":_setup.createExcel}})
}
var staticRenderFns = []

export { render, staticRenderFns }